import { isValidUrl, getNotifMsg } from 'utils';

// const OPERATOR_NOT_SELECTED_ERROR = 'انتخاب اپراتور الزامیست';

const getConditionError = (condition, locale = 'fa') => {
  if (condition.type === '') {
    return { type: getNotifMsg('AUTO_MSG_COMPLETE_CONDITION', locale) };
  }
  if (condition.type === 'time' && !condition.value) {
    return { seconds: getNotifMsg('FIELD_CANNOT_EMPTY', locale) };
  }

  if (['title', 'address'].includes(condition.type) && !condition.value) {
    return { address: getNotifMsg('FIELD_CANNOT_EMPTY', locale) };
  }

  if (
    ['address'].includes(condition.type) &&
    condition.eq === 'equal' &&
    !isValidUrl(condition.value)
  ) {
    return {
      address: getNotifMsg('ADDRESS_INVALID', locale),
    };
  }
};

export const getMessageError = (message, locale = 'fa') => {
  const errors = { conditions: {}, content: {}, publishTime: {} };
  const containsMsgTextTrigger = ['widgetOpensMessageSent', 'shortMessage'];
  const messageText = message.messageText;
  const isInvalidMessageText = !messageText || messageText === '<p><br></p>';
  if (
    containsMsgTextTrigger.includes(message.triggerAction) &&
    isInvalidMessageText
  ) {
    errors.content.messageText = getNotifMsg('FIELD_CANNOT_EMPTY', locale);
  }
  if (message.title === '') {
    errors.content.title = getNotifMsg('FIELD_CANNOT_EMPTY', locale);
  }

  if (
    containsMsgTextTrigger.includes(message.triggerAction) &&
    message.reachedMaxEditorChar
  ) {
    errors.content.messageText = getNotifMsg(
      'AUTO_MSG_EDITOR_MAX_CHAR',
      locale
    );
  }

  // if (Object.keys(message.sender).length === 0) {
  //   errors.content.operator = OPERATOR_NOT_SELECTED_ERROR;
  // }

  if (Object.keys(message.conditions).length === 0) {
    errors.conditions.emptyError = getNotifMsg(
      'AUTO_MSG_LEAST_CONDITION',
      locale
    );
  } else {
    for (let condition of message.conditions) {
      const error = getConditionError(condition, locale);
      if (error) {
        errors.conditions = { ...errors.conditions, [condition.id]: error };
      }
    }
  }

  // //TODO: any limitation error for title characters?

  // if (Object.keys(message.operator.length) === 0) {
  //   errors['operator'] = OPERATOR_NOT_SELECTED_ERROR;
  // }

  // for (let condition of message.conditions) {
  //   console.log(message);
  // }

  return errors;
};

export const checkHasError = (errorObj) => {
  return Object.values(errorObj).some((item) => Object.keys(item).length !== 0);
};

export const getNewMsgPreDefinedTitle = (messages, locale = 'fa') => {
  if (locale === 'en') {
    return `Condition ${messages.length + 1}`;
  }

  return `شرط ${messages.length + 1}`;
};

export const getInitialAutoMessage = (locale) => {
  const messageText =
    locale === 'en'
      ? 'Welcome to our site, we are at your service🖐'
      : 'به سایت ما خوش اومدین، در خدمتتون هستیم🖐';

  return {
    title: '',
    status: 'inActive',
    operator: '',
    lastUpdate: '',
    updatedBy: {},
    messageText,
    showType: 'complete',
    withVoice: true,
    sendMsgInMobile: true,
    showJustOnce: true,
    conditions: [],
    numberOfConditions: 'one',
    triggerAction: 'shortMessage',
    publishTime: {
      startPublishTime: new Date(),
      endPublishTime: 'never',
      allowedPublishTime: 'anyTime',
    },
  };
};
